import {
  BrandSystemProvider,
  themesBrandSystem,
} from 'libs/growth-platform-brand-system-v2/src/contexts/BrandSystemContext';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import {
  Tracking,
  page,
} from 'libs/growth-platform-brand-system-v2/src/utils/tracking';
import React, { FC, ReactNode, useEffect } from 'react';
import { getGlobalClassNames } from '../utils/getGlobalClassNames';
import { Footer } from './footer';
import { Header } from './header';
import { useDefaultMenu } from './header/useDefaultMenu';
import { getCookie } from './utils';
import { useTracking } from './track/useTracking';
interface ILayout {
  isBlueMenu?: boolean;
  specialBackground?: boolean;
  data: any;
  pageContext: any;
  tracking?: object;
  customHeader?: object;
  templateName?: string;
  children?: ReactNode;
  className?: string;
}

const isBrowser = typeof window !== 'undefined';

const Layout: FC<ILayout> = ({
  customHeader,
  children,
  pageContext,
  data,
  tracking,
  templateName,
  className,
}) => {
  useTracking();

  const trackingPageName =
    data?.trackingPageName?.title ??
    `NA : ${data?.slug} (${pageContext?.locale})`;
  const trackingPageType =
    data?.trackingPageCategory?.title ??
    `NA : ${data?.slug} (${pageContext?.locale})`;
  const trackingPageSubCategory =
    data?.subCategory?.slug ?? `NA : ${data?.slug} (${pageContext?.locale})`;
  const title = data?.metaFields?.title;
  const isPayfitAppUser = getCookie('payfit-app-user') === 'true';

  const trackingProperties = {
    countryCode: pageContext?.locale,
    pageType: trackingPageType,
    pageSubCategory: trackingPageSubCategory,
    payfitAppUser: isPayfitAppUser,
    ...tracking,
  };

  useEffect(() => {
    if (!isBrowser) return;

    const htmlTag = document.querySelector('html');
    htmlTag?.setAttribute('lang', pageContext?.locale);
    page(trackingPageName, { ...trackingProperties, title });

    if (!window.location.href.includes('#'))
      setTimeout(() => window.scrollTo(0, 0), 100);
  }, [data, pageContext?.locale]);

  const menu = useDefaultMenu(pageContext?.locale);

  const templateClassNames = getGlobalClassNames(
    data,
    pageContext?.locale,
    templateName,
  );

  return (
    <BrandSystemProvider
      value={{
        ...themesBrandSystem,
        language: pageContext?.locale,
        env: process.env.NODE_ENV,
        slug: data?.slug,
      }}
    >
      <Tracking.Provider
        value={{ page: trackingPageName, type: trackingPageType }}
      >
        <div
          data-slug={data?.slug}
          data-model={data?.__typename}
          data-locale={data?.locale}
          data-category={data?.subCategory?.category?.slug}
          data-subcategory={data?.subCategory?.slug}
          className={classNames('TrackingInfo', templateClassNames, className)}
        >
          <Header
            menu={!customHeader ? menu : customHeader}
            isCustomHeader={customHeader}
            disableBanner={data?.disableBanner}
            locale={pageContext.locale}
            publicityMode={data?.hero?.[0]?.publicityMode}
            pageContext={pageContext}
          />
          <main>{children}</main>
          <Footer
            locale={pageContext.locale}
            simplifiedFooter={data.simplifiedFooter}
            templateData={data}
          />
        </div>
      </Tracking.Provider>
    </BrandSystemProvider>
  );
};

export default Layout;
